import React, { useEffect, useState } from "react";
import "./contactPopup.css";

export default function ContactPopup({ open, onClose, position }) {
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    const formData = new FormData(e.target);

    const response = await fetch("https://formspree.io/f/xpqegjbl", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    });

    if (response.ok) {
      setStatus("Sent successfully!");
      e.target.reset();
      setTimeout(onClose, 1000);
    } else {
      setStatus("Failed. Try again.");
    }
  };

  if (!open) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div
        className="popup-box"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-btn" onClick={onClose}>✕</button>

        Schedule Site <span>Visit</span>

        <form onSubmit={handleSubmit}>
          <input name="name" placeholder="Name" required />
          <input name="phone" placeholder="Phone" />
          <input name="email" placeholder="Email" required />
          
          {/* <textarea name="message" placeholder="Message" required /> */}

          <button type="submit">Submit</button>
        </form>

        {status && <p>{status}</p>}
      </div>
    </div>
  );
}